module.exports = __webpack_public_path__ + "static/img/loading.6827e6b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading.gif
// module id = JRsF
// module chunks = 1